export default {
  InvalidParameterException: 'InvalidParameterException',
  InvalidPasswordException: 'InvalidPasswordException',
  NotAuthorizedException: 'NotAuthorizedException',
  LimitExceededException: 'LimitExceededException',
};
